const recompensas = [

	{
		tipo: "xp",
		valor: 50,
		texto: "+50 XP ⚡"
	},

	{
		tipo: "xp",
		valor: 100,
		texto: "+100 XP 🚀"
	},

	{
		tipo: "xp",
		valor: 250,
		texto: "+250 XP 🔥"
	},

	{
		tipo: "boost",
		valor: 2,
		texto: "Boost x2 XP por 1 hora ⚡"
	},

	{
		tipo: "ticket",
		valor: 1,
		texto: "🎟️ Ticket Ranked"
	},

	{
		tipo: "titulo",
		valor: "Prodigio",
		texto: "🏅 Nuevo título: Prodigio"
	}
];

const obtenerRecompensaRandom = () => {

	const random =
		Math.floor(
			Math.random() *
			recompensas.length
		);

	return recompensas[random];
};

export default obtenerRecompensaRandom;